import React  from 'react';
import {
    Form,Button, 
} from 'antd';

import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { InputField, required, phoneNumber, email,number} from '../../app/inputs/InputField';


let FormAgregarCliente = props => {
    return (
      <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
        <Field name="NOMBRE" component={InputField} ph="Nombre Cliente"/>
        <Field name="DIRECCIÓN" component={InputField} ph="Calle y numero"/>
        <Field name="COLONIA" component={InputField} ph="Poblacion"/>
        <Field name="POBLACIÓN" component={InputField} ph="Estado"/>
        <Field name="MUNICIPIO" component={InputField} ph="Municipio"/>
        <Field name="CP" component={InputField} ph="Codigo postal" validate={[required]} />
        <Field name="RFC" component={InputField} ph="RFC" validate={[required]} />
        <Field name="TELÉFONO" component={InputField} ph="Telefono" validate={[phoneNumber,number]}/>
        <Field name="CORREO" component={InputField} ph="Correo" validate={[email]}/>
        <Form.Item>
          <div style={{display:"flex", justifyContent:"center"}}>
            <Button loading={props.loading} type="primary" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )
  }

const mapStateToProps = (state, props) => {
  return {
    //initialValues:props.data
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 
  }
}
export default connect(mapStateToProps, mapDispatchToProps)( reduxForm({ form: 'FormAgregarCliente' })(FormAgregarCliente))